import React from "react";
import Typography from "../Text/Typography";
import "./Toggle.css";

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  labelVariant?: 'body' | 'body-small' | 'body-small-bold';
  id?: string;
  disabled?: boolean;
}

const Toggle: React.FC<ToggleProps> = ({ 
  checked, 
  onChange, 
  label, 
  labelVariant = 'body',
  id, 
  disabled = false 
}) => {
  return (
    <label className={`toggle-container ${disabled ? 'disabled' : ''}`} htmlFor={id}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={e => onChange(e.target.checked)}
        className="toggle-input"
        disabled={disabled}
      />
      <span className={`toggle-slider${checked ? " active" : ""}${disabled ? " disabled" : ""}`}></span>
      {label && (
        <Typography variant={labelVariant} className="toggle-label">
          {label}
        </Typography>
      )}
    </label>
  );
};

export default Toggle; 